import { render, staticRenderFns } from "./new-contractor-invite.vue?vue&type=template&id=97b84f8c&"
import script from "./new-contractor-invite.vue?vue&type=script&lang=js&"
export * from "./new-contractor-invite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports